import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

import type { AdNetworksRequestParams } from "../../company/types/ad-networks";

const COMPANY_INFO_QUERY_KEY = "account-overview:company-info";

const COMPANY_SIGNALS_OPEN_AI_QUERY_KEY = "account-overview:company-signals-openai";

const SIGNALS_EVENTS_TOOLTIP_QUERY_KEY = "account-overview:signals-events-tooltip";

const AD_NETWORKS_PIE_CHART_QUERY_KEY = "account-overview:ad-networks-pie-chart";

const AD_NETWORKS_TABLE_QUERY_KEY = "account-overview:ad-networks-table";

interface AccountOverviewQueryFactory extends QueryKeyFactory {
    companyInfo(companyDomain: string): readonly string[];

    companySignalsOpenAI(companyDomain: string): readonly string[];

    companySignalsEventsForTooltip(
        companyDomain: string,
        areRegionalDomainsIncluded?: boolean,
    ): readonly (string | boolean | undefined)[];

    adNetworksPieChart(params: AdNetworksRequestParams): readonly unknown[];

    adNetworksTable(params: AdNetworksRequestParams): readonly unknown[];
}

export const accountOverviewQueryKeys: AccountOverviewQueryFactory = {
    companyInfo(companyDomain) {
        return [COMPANY_INFO_QUERY_KEY, companyDomain];
    },
    companySignalsOpenAI(companyDomain) {
        return [COMPANY_SIGNALS_OPEN_AI_QUERY_KEY, companyDomain];
    },
    companySignalsEventsForTooltip(companyDomain, areRegionalDomainsIncluded) {
        return [SIGNALS_EVENTS_TOOLTIP_QUERY_KEY, companyDomain, areRegionalDomainsIncluded];
    },
    adNetworksPieChart(params) {
        return [AD_NETWORKS_PIE_CHART_QUERY_KEY, params];
    },
    adNetworksTable(params) {
        return [AD_NETWORKS_TABLE_QUERY_KEY, params];
    },
};
